<form #f="ngForm" (keydown.enter)="(false)">
  <div fxLayout="column" fxLayoutGap="16px">
    <h1 mat-dialog-title>{{ (editMode ? 'global.edit_terminal' : 'global.add_terminal') | translate }}</h1>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'global.company_id' | translate }}"
          [(ngModel)]="endUserTerminal.organization"
          name="id"
          [disabled]="true"
          required
          gtAlphanumericValidator
          gtMaxCharactersValidator
          #id="ngModel"
        />
        <mat-error>{{ id.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'global.login' | translate }}"
          [(ngModel)]="endUserTerminal.login"
          name="login"
          [disabled]="true"
          required
          gtAlphanumericValidator
          gtMaxCharactersValidator
          #login="ngModel"
        />
        <mat-error>{{ login.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field *ngIf="editMode">
        <input
          matInput
          placeholder="{{ 'contacts.col_number' | translate }}"
          value="{{ endUserTerminal.fullNumber | phoneNumberFormatter }}"
          name="fullNumber"
          [disabled]="true"
        />
      </mat-form-field>
      <mat-form-field *ngIf="!editMode">
        <input
          matInput
          placeholder="{{ 'contacts.col_number' | translate }}"
          [(ngModel)]="endUserTerminal.fullNumber"
          name="fullNumber"
          [disabled]="editMode"
          required
          gtPhoneNumberValidator
          #fullNumber="ngModel"
        />
        <mat-error>{{ fullNumber.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'contacts.col_short' | translate }}"
          [(ngModel)]="endUserTerminal.shortNumber"
          name="shortNumber"
          gtAlphanumericValidator
          #shortNumber="ngModel"
        />
        <mat-error>{{ shortNumber.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field>
        <mat-select
          placeholder="{{ 'contacts.col_terminal_type' | translate }}"
          [(ngModel)]="endUserTerminal.terminalType"
          name="terminalType"
          required
          #terminalType="ngModel"
        >
          <mat-option *ngFor="let type of terminalTypes" [value]="type.id">
            {{ type.name | translate }}
          </mat-option>
        </mat-select>
        <mat-error>{{ terminalType.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-select
          [(ngModel)]="endUserTerminal.category"
          placeholder="{{ 'contacts.col_category' | translate }}"
          required
          name="category"
          #category="ngModel"
        >
          <mat-option *ngFor="let cat of terminalCategories" [value]="cat.id">
            {{ cat.name | translate }}
          </mat-option>
        </mat-select>
        <mat-error>{{ category.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field>
        <mat-select
          [(ngModel)]="endUserTerminal.trunkProvider"
          placeholder="{{ 'contacts.col_trunk_provider' | translate }}"
          required
          name="trunkProvider"
          #trunkProvider="ngModel"
        >
          <mat-option *ngFor="let tp of trunkProviders" [value]="tp">
            {{ tp }}
          </mat-option>
        </mat-select>
        <mat-error>{{ trunkProvider.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-select
          [(ngModel)]="endUserTerminal.trunkId"
          placeholder="{{ 'contacts.col_trunk_id' | translate }}"
          required
          name="trunkId"
          #trunkId="ngModel"
        >
          <mat-option *ngFor="let t of trunks.get(endUserTerminal.trunkProvider)" [value]="t.id">
            {{ t.id }} ({{ t.description }})
          </mat-option>
        </mat-select>
        <mat-error>{{ trunkId.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-checkbox [(ngModel)]="endUserTerminal.inboundTriggering" name="inboundTriggering" color="primary">
        {{ 'contacts.col_inbound_triggering' | translate }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="endUserTerminal.outboundTriggering" name="outboundTriggering" color="primary">
        {{ 'contacts.col_outbound_triggering' | translate }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="endUserTerminal.enabled" name="enabled" color="primary">
        {{ 'contacts.col_enabled' | translate }}
      </mat-checkbox>
    </div>

    <div fxLayout="row" fxLayoutGap="5px">
      <button mat-button (click)="onCancelClick()" color="primary" class="btn btn-default">
        {{ 'global.cancel' | translate }}
      </button>
      <button mat-raised-button (click)="onSaveClick()" color="primary" class="btn btn-default" [disabled]="f.invalid">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</form>
